import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormElementViewModel, IFormElementViewModel, IFormElementViewModelOptions } from '../forms';

@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss']
})
export class FormInputComponent implements OnInit {

  text: string = '';
  validationErrors: string[] = [];

  @Input() vm: IFormInputViewModel;

  @Output() textChanged = new EventEmitter<IFormInputTextChangedArg>();
  @Output() textEntered = new EventEmitter<IFormInputTextChangedArg>();

  @ViewChild('input') inputElement: ElementRef;

  /// todo... add via view model / input
  inputAutocomplete: string = 'off';

  /**
   *
   */
  constructor() { }

  /**
   *
   * @param e
   */
  modelChanged(e) {
    if (!this.vm)
      return;

    this.vm.dataSet(this.vm.type == 'number' ? Number.parseInt(e) : e);
    this.text = e;

    this.validationErrors = this.vm.validate(this.vm);

    this.textChanged.emit({
      sender: this, errors: this.validationErrors, text: e,
      number: this.vm.type == 'number' ? Number.parseInt(e) : undefined
    });
  }

  /**
   *
   * @param e
   */
  keyUpEntered(e) {
    if(!this.vm)
      return;

    this.textEntered.emit({
      sender: this, errors: this.validationErrors, text: e,
      number: this.vm.type == 'number' ? Number.parseInt(e) : undefined
    });
  }

  /**
   *
   */
  ngOnInit() {
    if (!this.vm) {
      this.validationErrors = [ 'no view model' ];
      return;
    }

    this.text = this.vm.dataGet();
    this.validationErrors = this.vm.validate(this.vm);  

    console.log(this.text);
  }

  focus() {
    this.inputElement.nativeElement.focus();
  }

  /**
   *
   */
  ngOnChanges() {
    if (!this.vm)
      return;
    this.validationErrors = this.vm.validate(this.vm);
  }


  /**
   * 
   * @param context 
   * @param field 
   * @param action 
   * @param apiPath 
   * @param options 
   * @returns 
   */
   public static viewModel(context: any, field: string, options: IFormInputOptions, elementInstance: number = undefined): IFormInputViewModel {
    const ret: IFormInputViewModel = {
      ...FormElementViewModel.create(context, field, options, elementInstance),

      type: options?.type ?? 'text',

      validate: (vm: IFormInputViewModel) => {
        const errors: string[] = [
          vm.isRequired && (vm.dataGet() ?? "").length == 0 ? 'Required' : undefined,
          (vm.minLength ?? 0) > 0 && (vm.dataGet() ?? "").length < vm.minLength ? `Min length '${vm.minLength}'` : undefined
        ];
        return errors.filter(e => e);
      }
    };
    return ret;
  }  

}

/**
 *
 */
export interface IFormInputTextChangedArg {
  sender: FormInputComponent;
  errors: string[];

  text: string;
  number?: number;
}

/**
 * 
 */
export interface IFormInputViewModel extends IFormElementViewModel, IFormInputOptions {

}

/**
 * 
 */
export interface IFormInputOptions extends IFormElementViewModelOptions {
  minLength?: number;

  type?: string;
}

